import React from 'react'

// Actions
import { useModal } from '../_reduxHooks/modal.hook'

// Components
import Table from '../_components/Table'
import { createColumn } from '../_components/TableColumn'
import { Button } from '../_components/Button'
import { ChecksModal } from './ChecksModal'

export const BusinessPaymentsTableColumns = [
  createColumn({
    type: 'date',
    id: 'posted_date',
    headingText: 'Date Posted',
    disableSortBy: true,
  }),
  {
    accessor: 'batch_number',
    headingText: 'Batch Number',
    disableSortBy: true,
  },
  {
    accessor: 'check_number',
    headingText: 'Check/Transaction #',
    disableSortBy: true,
  },
  createColumn({
    type: 'currency',
    id: 'amount',
    headingText: 'Amount',
    disableSortBy: true,
  }),
  {
    type: 'count',
    id: 'documents',
    headingText: 'Documents',
    disableSortBy: true,
    Cell: ({ row }) => {
      const { openModal } = useModal()

      const userData = row.original
      const { documents } = userData
      return (
        <div className={`align-right`}>
          <Button
            buttonType={`button`}
            className="compact"
            disabled={documents.length === 0}
            onClick={() =>
              openModal(ChecksModal, {
                documents,
              })
            }
            text="View"
          />
        </div>
      )
    },
  },
]

export const BusinessPaymentsTable = ({
  results,
  sort = [],
  handleSortChange = () => {},
  pageSize,
  columns = BusinessPaymentsTableColumns,
  handleRowClick = null,
}) => {
  if (!results || results.length === 0) {
    return null
  }

  return (
    <Table
      columns={columns}
      data={results}
      handleRowClick={handleRowClick}
      onSortedChange={handleSortChange}
      pageSize={pageSize}
      sorted={sort}
    />
  )
}
